module.exports = __webpack_public_path__ + "media/images/icons/ic-success-c70e5645425eee8ec9da4fe67f04513a.svg";